import { MessageAccessType } from './enums/message';

export const selectAllOption = { label: 'Everyone', value: '*' };

export const matchTrailingSpacesIgnoringLineBreaks = / {2,}(?!\n)/g;

export const matchMentionsUserTag = /@\[.*?\)/g; // @[*)
export const matchLineBreaksOrMentionsUserTag = /(\n|@[^\n)]*\))/g; // \n | @[*)
export const matchMentionsUserTagEmail = /\((.*?)\)/; // (*)
